import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  menuItems: MenuItem[];

  constructor() {
    this.menuItems = [
      { label: 'Home', routerLink: ['/'] },
      {
        label: 'Browse Jobs',
        routerLink: ['jobs'],
        items: [
          { label: 'DEDICATED', routerLink: ['jobs', { division: 'DEDICT' }] },
          { label: 'OVER THE ROAD', routerLink: ['jobs', { division: 'OVER_THE_ROAD' }] },
          { label: 'INTERMODAL', routerLink: ['jobs', { division: 'INTMDL' }] },
          { label: 'I NEED MY CDL', routerLink: ['jobs', { experience: '0' }] },
        ],
      },
    ];
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollEvent, true);
  }

  ngOnInit() {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  openMobileNavBar() {
    document.getElementById('mobileNavBar').classList.toggle('open');
    const navigation = document.getElementById('navigation');
    navigation.classList.toggle('open');
  }

  scrollEvent(event: any): void {
    const scrollingElement = event.srcElement.scrollingElement;
    if (scrollingElement) {
      const scroll = scrollingElement.scrollTop;
      if (scroll >= 80) {
        document.getElementById('topnav').classList.add('scroll');
      } else {
        document.getElementById('topnav').classList.remove('scroll');
      }
    }
  }

  toggleMobileSubMenu(event: any) {
    const element = event.target;
    if (element.innerText === 'CAREERS') {
      event.target.nextElementSibling.classList.toggle('open');
      event.target.nextElementSibling.nextElementSibling.classList.toggle('open');
    } else {
      event.target.classList.toggle('open');
      event.target.nextElementSibling.classList.toggle('open');
    }
  }
}
